import React, { useState } from "react";
import { ExerciseTypeContainer } from "./ExerciseTypeContainer";

type PronunciationPracticeProps = {
  item: {
    id: number | string;
    name: string;
    title?: string;
    description?: string;
    content?: string;
  };
};

export const PronunciationPractice: React.FC<PronunciationPracticeProps> = ({ item }) => {
  console.log("PronunciationPractice received item:", item);
  
  const [isRecording, setIsRecording] = useState(false);
  const [recordingComplete, setRecordingComplete] = useState(false);
  const [feedback, setFeedback] = useState<string | null>(null);
  
  // Create a default pronunciation word from the exercise title
  const titleSentence = item.title || "Thought Through Thorough";
  
  // Use the title as the pronunciation task
  const pronunciationWords = [
    { 
      word: titleSentence, 
      phonetic: "", 
      audio: "#" 
    }
  ];

  const handleListenDemo = (audio: string) => {
    // In a real implementation, this would play the sample audio
    console.log(`Playing demo audio: ${audio}`);
  };

  const handleStartRecording = () => {
    setIsRecording(true);
    setRecordingComplete(false);
    setFeedback(null);
    
    // Simulate recording process with a timer
    setTimeout(() => {
      setIsRecording(false);
      setRecordingComplete(true);
      // Mock feedback
      setFeedback("Sua pronúncia está boa, mas tente enfatizar mais a clareza em cada palavra.");
    }, 3000);
  };

  return (
    <ExerciseTypeContainer
      item={item as never}
      title1="Prática de pronúncia"
      title2="Pratique a pronúncia da frase"
      subtitle={item.description || "Tente reproduzir a frase exatamente como seria falada naturalmente"}
      exerciseNumber={`exercício n. ${item.id}`}
      hideVerifyButton
    >
      <div className="mt-6">
        <div className="space-y-4">
          {pronunciationWords.map((wordItem, index) => (
            <div key={index} className="flex items-center p-3 border-b border-gray-200">
              <div className="flex-1">
                <div className="text-lg font-medium">{wordItem.word}</div>
                {wordItem.phonetic && <div className="text-sm text-gray-500">{wordItem.phonetic}</div>}
              </div>
              <button
                onClick={() => handleListenDemo(wordItem.audio || "#")}
                className="p-2 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors mr-3"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15.465a5 5 0 001.06-7.07l5.658-5.657a1 1 0 011.414 0l5.657 5.657a1 1 0 010 1.414l-5.657 5.657a1 1 0 01-1.414 0l-5.657-5.657a1 1 0 010-1.414z" />
                </svg>
              </button>
            </div>
          ))}
        </div>
        
        <div className="mt-8 flex flex-col items-center">
          <div className="text-center mb-4">
            Agora pratique sua pronúncia com a frase inteira
          </div>
          
          {!isRecording && !recordingComplete ? (
            <button
              onClick={handleStartRecording}
              className="px-4 py-2 bg-red-500 text-white rounded-full hover:bg-red-600 transition-colors flex items-center gap-2"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <circle cx="10" cy="10" r="5" />
              </svg>
              Iniciar Gravação
            </button>
          ) : isRecording ? (
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
              <span>Gravando...</span>
            </div>
          ) : (
            <div className="w-full">
              <button
                onClick={handleStartRecording}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded-full hover:bg-gray-300 transition-colors"
              >
                🔄 Gravar novamente
              </button>
              
              {feedback && (
                <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                  <div className="font-medium">Feedback:</div>
                  <p>{feedback}</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </ExerciseTypeContainer>
  );
}; 